import metadata from "$public/metadata.json";
import { capitalize } from "$utils/capitalize";
export const categoryTypeChoices = metadata.Category.type.type
    .sort()
    .map((id) => ({ id, name: capitalize(id).replaceAll("_", " ") }));
export const nonValueBitCategoryTypeChoices = categoryTypeChoices.filter((choice) => choice.id !== "VALUE_BIT_TAG");
